module.exports = __webpack_public_path__ + "img/logo.df1f7733.png";